import { render, staticRenderFns } from "./exam-test.vue?vue&type=template&id=5641d133"
import script from "./exam-test.vue?vue&type=script&lang=js"
export * from "./exam-test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5641d133')) {
      api.createRecord('5641d133', component.options)
    } else {
      api.reload('5641d133', component.options)
    }
    module.hot.accept("./exam-test.vue?vue&type=template&id=5641d133", function () {
      api.rerender('5641d133', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/exam-test.vue"
export default component.exports